import { formatFixed } from "Util"

const QaisScore = ({ data }) => {

  function renderingComment() {
    if (data.qais.SCORE_STEP === 1) {
      return (
        <div className="box">
          <div className="number txt_red">{formatFixed(data.qais.SCORE, 0)}점</div>
          <div className="text">{data.TICKER_NAME} 종합점수는 <br/><span className="txt_red">매우 낮은</span> 수준입니다</div>
        </div>
      )
    } else if (data.qais.SCORE_STEP === 2) {
      return (
        <div className="box">
          <div className="number txt_orange">{formatFixed(data.qais.SCORE, 0)}점</div>
          <div className="text">{data.TICKER_NAME} 종합점수는 <br/><span className="txt_orange">낮은</span> 수준입니다</div>
        </div>
      )

    } else if (data.qais.SCORE_STEP === 3) {
      return (
        <div className="box">
          <div className="number txt_yellow">{formatFixed(data.qais.SCORE, 0)}점</div>
          <div className="text">{data.TICKER_NAME} 종합점수는 <br/><span className="txt_yellow">보통</span> 수준입니다</div>
        </div>
      )
    } else if (data.qais.SCORE_STEP === 4) {
      return (
        <div className="box">
          <div className="number txt_green">{formatFixed(data.qais.SCORE, 0)}점</div>
          <div className="text">{data.TICKER_NAME} 종합점수는 <br/><span className="txt_green">높은</span> 수준입니다</div>
        </div>
      )
    } else if (data.qais.SCORE_STEP === 5) {
      return (
        <div className="box">
          <div className="number txt_darkgreen">{formatFixed(data.qais.SCORE, 0)}점</div>
          <div className="text">{data.TICKER_NAME} 종합점수는 <br/><span className="txt_darkgreen">매우 높은</span> 수준입니다</div>
        </div>
      )
    } else {
      return (
        <div className="box">
          <div className="learn"></div>
          <div className="text txt_gray"><span className="txt_gray">학습</span> 하고 있습니다.</div>
        </div>
      )
    }
  }

  function renderingBar() {
    let iClass = "bars bars" + data.qais.SCORE_STEP;
    const result = [];
    for (let i = 0; i < 5; i++) {
      result.push(
        <i key={i} className={i < data.qais.SCORE_STEP ? 'full': ''}></i>
      );
    }

    return (
      <div className={iClass}>
        {result}
      </div>
    )
  }

  return (
    <div style={{background:'#172447', color:'#fff', borderRadius:10, padding:18}}>
  <div className="grade" style={{background: 'transparent', padding: 0, borderRadius: 0, boxShadow: 'none'}}>
        <div className="lt">
          <div className="icon"><img src="/static/images/icon_certify3.png" alt="" /></div>
          <div className="title">QAIS 종합점수</div>
          {renderingBar()}
        </div>
        <div className="rt">
          {renderingComment()}
        </div>
      </div>

      <div style={{height:12}} />
      <div style={{borderTop: '1px solid #fff', opacity:0.12}} />
      <div style={{fontSize:14, fontWeight:600, marginTop:12, color:'#fff', lineHeight:1.8}}>
        <div style={{fontWeight:700, marginBottom:0, fontSize:16}}>QAIS(Quin AI Score) 종합 점수</div>
        <div>※ 성장성, 가치, 성과, 안정성, 모멘텀 등 5개 핵심 변수와 세부 요인을 학습하여 기업 가치를 0 ~ 100점으로 상대평가한 결과입니다.</div>
        <div>※ 점수가 100에 가까울수록 기업의 전반적인 펀더멘탈과 모멘텀이 우수함을 의미합니다.</div>
      </div>
    </div>
  );
}

export default QaisScore;
